'use client'

import { Notification } from '@/features/notification/model/notification'
import { TranslationBundles } from '@/features/sitecore/configs/translation-bundles'
import { useSitecoreState } from '@/features/sitecore/store/useSitecoreState'
import { NotificationItem } from '../uiComponents'
import styles from './NotificationTab.module.css'

export interface NotificationTabsProps {
	type: string
	notifications: Notification[]
	retrieveMoreNotifications: (type: string) => void
	read: (notificationId: number) => void
	cancel: (notificationId: number) => void
}

export const NotificationTab = (props: NotificationTabsProps) => {
	const sitecoreStore = useSitecoreState((state) => state)

	const tabLabel = sitecoreStore.getLabel(TranslationBundles.NOTIFICATIONS, `NOTIFICATION-TAB-${props.type.toUpperCase()}`, props.type.toUpperCase())
	const noNotificationsLabel = sitecoreStore.getLabel(TranslationBundles.NOTIFICATIONS, 'NOTIFICATION-EMPTY', 'No notifications')

	const noNotificationsContent = (
		<div className="flex flex-col justify-center w-full h-full text-center">
			<p className="text-light-purple">{noNotificationsLabel}</p>
		</div>
	)

	// eslint-disable-next-line prettier/prettier
	const notificationContent = props.notifications.map((notification, index) => <NotificationItem key={index} tabLabel={tabLabel} notification={notification} read={props.read} cancel={props.cancel} />)

	const handleScroll = (e: React.UIEvent<HTMLUListElement>) => {
		const { scrollTop, scrollHeight, clientHeight } = e.currentTarget
		if (scrollTop + clientHeight >= scrollHeight) {
			props.retrieveMoreNotifications(props.type)
		}
	}

	return (
		<ul onScroll={handleScroll} className={`${styles.notificationList} max-h-96 md:max-h-60 h-full overflow-y-scroll`}>
			{props.notifications.length === 0 ? noNotificationsContent : notificationContent}
		</ul>
	)
}
